/*
 * Please do not add more to this file as this will be deprecated.
 */
import { Folder } from 'owa-folders';
import { TableView } from 'owa-mail-list-store';

export let actionNames = {
    DeleteConversationStoreUpdate: 'deleteConversationStoreUpdate',
    EmptyFolderStoreUpdate: 'emptyFolderStoreUpdate',
    DeleteFolderAction: 'deleteFolderAction',
    ForwardMessageAction: 'forwardMessageAction',
    LoadDraftToComposeAction: 'loadDraftToComposeAction',
    MarkAllAsReadStoreUpdate: 'markAllAsReadStoreUpdate',
    ReloadMailListTableAction: 'reloadMailListTableAction',
    SingleMailItemSelectedAction: 'singleMailItemSelectedAction',
    SendFeedbackActionName: 'SendFeedbackAction',
};

export interface MarkAllAsReadStoreUpdate {
    (tableView: TableView, markAsRead: boolean, rowKeysToExclude?: string[]): void;
}

export interface EmptyFolderStoreUpdate {
    (
        folder: Folder,
        clientLastSyncTime: Date,
        deletedItemsFolderId: string,
        rowKeysToExclude?: string[]
    ): void;
}

export interface DeleteFolderAction {
    (folderIds: string[]): void;
}

export interface SingleMailItemSelectedAction {
    (itemId: string, isUserNavigation: boolean, itemSubject: string): void;
}

export interface DeleteConversationStoreUpdate {
    (conversationIds: string[], tableView: TableView): void;
}

export interface ReloadMailListTableAction {
    (tableView: TableView, rowsToRefresh?: number): void;
}

export interface SendFeedbackAction {
    (message: string, rating: number, screenshot: Blob, onFeedbackSent?: () => void): void;
}
